import * as React from 'react';
import HyperLinkRenderer from 'components/common/DataGridDevEx/CustomRenderers/HyperLinkRenderer';
import { useSPContextSelector } from 'components/Worksale/Worksale.context';
import Selectors from 'components/Worksale/Worksale.selectors';

const HyperLinkCell = ({ data }) => {
    const CustomerId = useSPContextSelector(Selectors.CustomerId);
    const SalesEntity = useSPContextSelector(Selectors.salesEntity);

    return <HyperLinkRenderer value={{ ProductId: data?.data?.ProductId, WarehouseEntity: data?.data?.WarehouseEntity, CustomerId, SalesEntity, SalesQuantity: 1, FieldValue: `${data?.data?.PriceDisplay}` }} colDef={{ headerName: 'Price Check' }} link='price-check' />;
};

export default HyperLinkCell;
